__turbopack_context__.v({
  "activeBar": "index-module__lkXZKW__activeBar",
  "description": "index-module__lkXZKW__description",
  "downloadButton": "index-module__lkXZKW__downloadButton",
  "skeleton-wave": "index-module__lkXZKW__skeleton-wave",
  "skeletonWave": "index-module__lkXZKW__skeletonWave",
  "spectrumBar": "index-module__lkXZKW__spectrumBar",
  "wrapper": "index-module__lkXZKW__wrapper",
  "zoomSlider": "index-module__lkXZKW__zoomSlider",
});
